import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  collection,
  getDocs,
  query,
  orderBy,
  where,
  doc,
  getDoc
} from 'firebase/firestore';
import { db } from '../../../firebase';

export const getAllBicycles = createAsyncThunk(
  'shopBikeData/fetchBicycles',
  async (data) => {
    let news = [];
    try {
      if (data?.rol === 'admin') {
        const q = query(collection(db, 'news'), orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          news.push({ id: doc.id, ...doc.data() });
        });
      } else if (data?.rol === 'owner') {
        const q = query(
          collection(db, 'news'),
          where('companyId', '==', data.companyId),
          orderBy('createdAt', 'desc')
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          news.push({ id: doc.id, ...doc.data() });
        });
      } else {
        const q = query(
          collection(db, 'news'),
          where('companyId', '==', 'Ext9DqJDAkmzP030L1Os'),
          orderBy('createdAt', 'desc')
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          news.push({ id: doc.id, ...doc.data() });
        });
      }
    } catch (error) {
      console.log('error getting news', error);
    }

    return news;
  }
);

export const getAllUser = createAsyncThunk(
  'shopBikeData/fetchUsers',
  async (data) => {
    let users = [];
    try {
      if (data?.rol === 'admin') {
        const q = query(collection(db, 'users'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          users.push({ id: doc.id, ...doc.data() });
        });
      } else if (data.rol === 'owner') {
        const q = query(
          collection(db, 'users'),
          where('companyId', '==', data.companyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          users.push({ id: doc.id, ...doc.data() });
        });
      } else {
        const q = query(collection(db, 'users'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          users.push({ id: doc.id, ...doc.data() });
        });
      }
    } catch (error) {}

    return users;
  }
);

export const getUsers = createAsyncThunk(
  'shopBikeData/getUsers',
  async (data) => {
    let users = [];
    try {
      if (data?.rol === 'admin') {
        const q = query(collection(db, 'users'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          users.push({ id: doc.id, ...doc.data() });
        });
      } else if (data.rol === 'owner') {
        const q = query(
          collection(db, 'users'),
          where('companyId', '==', data.companyId)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          users.push({ id: doc.id, ...doc.data() });
        });
      } else {
        const q = query(
          collection(db, 'users'),
          where('companyId', '==', 'Ext9DqJDAkmzP030L1Os')
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          users.push({ id: doc.id, ...doc.data() });
        });
      }
    } catch (error) {
      console.log('errror getting list users', error);
    }

    return users;
  }
);

export const getCompanies = createAsyncThunk(
  'shopBikeData/getCompanies',
  async () => {
    const q = query(collection(db, 'companies'));
    const querySnapshot = await getDocs(q);
    let companies = [];
    querySnapshot.forEach((doc) => {
      companies.push({ id: doc.id, ...doc.data() });
    });

    return companies;
  }
);

export const getSections = createAsyncThunk(
  'shopBikeData/getSections',
  async (data) => {
    let sections = [];
    try {
      if (data?.rol === 'admin') {
        const q = query(collection(db, 'sections'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          sections.push({ id: doc.id, ...doc.data() });
        });
      } else if (data?.rol === 'owner') {
        const q = query(
          collection(db, 'sections'),
          where('companyId', '==', data.id)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          sections.push({ id: doc.id, ...doc.data() });
        });
      } else {
        const q = query(
          collection(db, 'sections'),
          where('companyId', '==', 'Ext9DqJDAkmzP030L1Os')
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          sections.push({ id: doc.id, ...doc.data() });
        });
      }
    } catch (error) {
      console.log('error geting sections', error);
    }

    return sections;
  }
);

export const getNews = createAsyncThunk(
  'shopBikeData/getNews',
  async (data) => {
    let news = [];

    try {
      if (data?.rol === 'admin') {
        const q = query(collection(db, 'news'));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          news.push({ id: doc.id, ...doc.data() });
        });
      } else if (data?.rol === 'owner') {
        const q = query(
          collection(db, 'news'),
          where('companyId', '==', data?.id)
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          news.push({ id: doc.id, ...doc.data() });
        });
      } else {
        const q = query(
          collection(db, 'news'),
          where('companyId', '==', 'Ext9DqJDAkmzP030L1Os')
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          news.push({ id: doc.id, ...doc.data() });
        });
      }
    } catch (error) {}

    return news;
  }
);

export const getCompany = createAsyncThunk(
  'shopBikeData/getCompany',
  async (id) => {
    const ref = doc(db, 'companies', id);
    const docSnap = await getDoc(ref);
    const company = docSnap.data();
    return company;
  }
);

export const getNew = createAsyncThunk('shopBikeData/getNew', async (id) => {
  const ref = doc(db, 'news', id);
  const docSnap = await getDoc(ref);
  const data = docSnap.data();
  return data;
});

export const getSection = createAsyncThunk(
  'shopBikeData/getSection',
  async (id) => {
    const ref = doc(db, 'sections', id);
    const docSnap = await getDoc(ref);
    const section = docSnap.data();
    return section;
  }
);

export const getUser = createAsyncThunk('shopBikeData/getUser', async (id) => {
  const ref = doc(db, 'users', id);
  const docSnap = await getDoc(ref);
  const user = docSnap.data();
  return user;
});

export const getBicyclesByType = createAsyncThunk(
  'shopBikeData',
  async (search) => {
    // @ts-ignore
    if (search === 'electrics') {
      return await axios
        .get('/bicyclesElectrics', { params: { searchText: search } })
        .then((res) => {
          return res.data.bicyclesElectrics;
        });
    }
    // @ts-ignore
    if (search === 'old') {
      return await axios
        .get('/bicyclesOlds', { params: { searchText: search } })
        .then((res) => {
          return res.data.bicyclesOlds;
        });
    }
    // @ts-ignore
    if (search === 'normal') {
      return await axios
        .get('/bicyclesNormal', { params: { searchText: search } })
        .then((res) => {
          return res.data.bicyclesNormal;
        });
    }
    // @ts-ignore
    if (search === 'all') {
      return await axios.get('/bicycles').then((res) => {
        return res.data.bicycles;
      });
    }
  }
);
